type CarouselState = {
  activeIndex: number;
  isLoading: boolean;
  carouselLength: number;
  shouldLoop: boolean;
};

enum CarouselActionType {
  Next = 'NEXT',
  Prev = 'PREV',
  SetLoading = 'SET_LOADING'
}

type CarouselAction =
  | { type: CarouselActionType.Next }
  | { type: CarouselActionType.Prev }
  | { type: CarouselActionType.SetLoading; isLoading: boolean };

const carouselReducer = (state: CarouselState, action: CarouselAction) => {
  const { activeIndex, carouselLength, shouldLoop } = state;
  switch (action.type) {
    case CarouselActionType.Next: {
      let nextIndex = activeIndex;
      if (shouldLoop) {
        nextIndex = (activeIndex + 1) % carouselLength;
      } else if (nextIndex !== carouselLength - 1) {
        nextIndex = activeIndex + 1;
      }

      return {
        ...state,
        activeIndex: nextIndex
      };
    }
    case CarouselActionType.Prev: {
      let prevIndex = activeIndex;
      if (shouldLoop) {
        prevIndex = (activeIndex + carouselLength - 1) % carouselLength;
      } else if (prevIndex !== 0) {
        prevIndex = activeIndex - 1;
      }

      return {
        ...state,
        activeIndex: prevIndex
      };
    }
    case CarouselActionType.SetLoading:
      return {
        ...state,
        isLoading: action.isLoading
      };
    default:
      return state;
  }
};

export { carouselReducer, type CarouselAction, CarouselActionType, type CarouselState };
